<template>
  <section class="side-sessions">
    <div class="side-sessions--search">
      <search @searchFilter="filterData.search = $event" />
      <filters @changeFilters="changeFilterData" />
    </div>
    <div class="side-sessions-wrapper">
      <sessions-list
        v-for="(session, index) in sessions"
        :key="index"
        :selected-session="selectedSession"
        :sessionData="session"
        @selectSession="selectSession"
      />
    </div>
    <sessions-pages
      :page="page"
      :sessions-total="sessionsTotal"
      :per-page="perPage"
      @prevPage="prevSessions"
      @nextPage="nextSessions"
    />
  </section>
</template>

<script>
import _ from "lodash";
import infiniteScroll from "vue-infinite-scroll";
import filters from "./filters";
import search from "./search";
import sessionsList from "./sessionsList";
import sessionsPages from "./sessionsPages";
export default {
  name: "sideSessions",
  components: {
    search,
    filters,
    sessionsList,
    sessionsPages,
  },
  directives: { infiniteScroll },
  data() {
    return {
      filterData: {
        search: "",
        filters: {
          attributes: [],
          channels: [],
          status: [],
          date: {
            from: "",
            to: "",
          },
        },
      },
      perPage: 50,
      page: 1,
      sessionsTotal: 0,
      sessions: [],
      hasNext: false,
      selectedSession: {},
    };
  },
  async mounted() {
    await this.getSessions();
  },
  methods: {
    async getSessions(loadMore) {
      const urlParams = new URLSearchParams(window.location.search);
      let session_id = urlParams.get("session_id");
      let conversation_id = urlParams.get("conversation_id");

      let url = "/sessions";

      if (session_id) {
        this.filterData.search = session_id;
      }

      if (conversation_id) {
        this.filterData.search = conversation_id;
        url = "/conversations";
      }

      this.$store.dispatch("setLoader", true);
      let attributes = this.formatAttributes();
      const response = await this.$http_session_manager.get(url, {
        params: {
          "filter[bot]": this.$store.state.bot.botId,
          per_page: this.perPage,
          page: this.page,
          ...(this.filterData.filters.channels.length && {
            "filter[channel]": this.filterData.filters.channels.toString(),
          }),
          ...(this.filterData.filters.status.length && {
            "filter[status]": this.filterData.filters.status.toString(),
          }),
          ...attributes,
          ...(this.filterData.search && {
            "filter[user_display_name]": this.filterData.search,
          }),
          ...(this.filterData.filters.date.from && {
            from: this.filterData.filters.date.from.replace(/-/g, "/"),
          }),
          ...(this.filterData.filters.date.to && {
            to: this.filterData.filters.date.to.replace(/-/g, "/"),
          }),
        },
      });

      if (loadMore) {
        this.sessions = response.data.sessions;
      } else {
        let sessions = response.data.sessions;
        this.sessions = sessions;
        this.hasNext = response.data.hasNext;
        this.sessionsTotal = response.data.count;
        if (sessions.length) {
          this.selectedSession = _.cloneDeep(response.data.sessions[0]);
          this.$emit("selectSession", this.selectedSession);
          document.getElementsByClassName(
            "side-sessions-wrapper"
          )[0].scrollTop = 0;
        } else {
          throw "No sessions match the filter criteria. Please adjust the filter criteria and try again.";
        }
      }
    },
    formatAttributes() {
      this.attributesStr = {};
      for (let i = 0; i < this.filterData.filters.attributes.length; i++) {
        if (
          this.filterData.filters.attributes[i].key &&
          this.filterData.filters.attributes[i].value &&
          this.filterData.filters.attributes[i].key !== "session_id"
        ) {
          this.attributesStr[
            `attributes[${this.filterData.filters.attributes[i].key}]`
          ] = this.filterData.filters.attributes[i].value;
        } else if (
          this.filterData.filters.attributes[i].key &&
          this.filterData.filters.attributes[i].value &&
          this.filterData.filters.attributes[i].key === "session_id"
        ) {
          this.attributesStr[`filter[_id]`] =
            this.filterData.filters.attributes[i].value;
        }
      }
      return this.attributesStr;
    },
    changeFilterData(data) {
      this.filterData.filters = _.cloneDeep(data);
    },
    async scrollToMoreSessions() {
      if (this.hasNext) {
        this.page++;
        await this.getSessions(true);
      }
    },
    async nextSessions() {
      
      this.page++;
      await this.getSessions();
    },
    async prevSessions() {
      this.page--;
      await this.getSessions();
    },
    selectSession(session) {
      this.selectedSession = _.cloneDeep(session);
      this.$emit("selectSession", this.selectedSession);
    },
  },
  watch: {
    filterData: {
      async handler() {
        this.page = 1;
        await this.getSessions();
      },
      deep: true,
    },
  },
};
</script>

<style scoped></style>
